exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IconButton {\n  cursor: pointer; }\n  .IconButton:hover {\n    transform: scale(1.1); }\n  .IconButton--rounded {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    background-color: #212121dd;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center; }\n", ""]);

